import * as RadixPopover from '@radix-ui/react-popover'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface DsPopoverProps {
  trigger: ReactNode
  children: ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  /** Panel width: sm 280 · md 360 · lg 440. */
  width?: 'sm' | 'md' | 'lg'
  semanticLabel?: string
  className?: string
}

const widthClass = { sm: 'w-[280px]', md: 'w-[360px]', lg: 'w-[440px]' }

// On phones prefer DsSheet: a popover this wide does not fit.
export function DsPopover({ trigger, children, open, onOpenChange, side = 'bottom', align = 'end', width = 'md', semanticLabel, className }: DsPopoverProps) {
  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          side={side}
          align={align}
          sideOffset={8}
          collisionPadding={16}
          aria-label={semanticLabel}
          className={cn('z-50 max-h-[min(560px,var(--radix-popover-content-available-height))] max-w-[calc(100vw-32px)] overflow-y-auto rounded-xl border bg-popover text-popover-foreground shadow-lg outline-none animate-ds-scale-in', widthClass[width], className)}
        >
          {children}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  )
}

export const DsPopoverClose = RadixPopover.Close
